import React from "react";
import Highlight from "../Highlight";

const CATEGORIES = [
  {
    n: "01",
    name: "SDRs & sales development",
    desc: "Outbound that sounds human. Pipeline, booked and kept warm.",
  },
  {
    n: "02",
    name: "Account executives",
    desc: "Closers who carry a quota and understand your buyer.",
  },
  {
    n: "03",
    name: "Customer success",
    desc: "Onboarding, retention and renewals that protect your revenue.",
  },
  {
    n: "04",
    name: "RevOps analysts",
    desc: "Clean data, working funnels and dashboards that tell the truth.",
  },
  {
    n: "05",
    name: "GTM & lifecycle marketing",
    desc: "Campaigns, sequences and growth loops that actually run.",
  },
  {
    n: "06",
    name: "Virtual assistants",
    desc: "Executive and ops support that gives you your week back.",
  },
  {
    n: "07",
    name: "Vibe-coding engineers",
    desc: "AI-native builders who ship features and prototypes fast.",
  },
  {
    n: "08",
    name: "Sales operations",
    desc: "CRM hygiene, forecasting and the plumbing behind the pipeline.",
  },
];

export default function Categories() {
  return (
    <section
      id="categories"
      className="mx-auto max-w-[1200px] px-6 pb-24 pt-12 lg:px-10"
    >
      <div className="mb-9 flex flex-wrap items-end justify-between gap-6">
        <h2 className="text-balance text-[clamp(32px,4vw,48px)] font-bold leading-[1.05] tracking-[-0.025em]">
          What do you need <Highlight>done</Highlight>?
        </h2>
        <a
          href="#talent-grid"
          className="whitespace-nowrap text-[15px] font-bold leading-none text-ink-v2 transition-colors duration-120 hover:text-coral-500"
        >
          See all categories &rarr;
        </a>
      </div>

      {/* The 1.5px gap over an ink background is what draws the hairline rules */}
      <div className="grid grid-cols-1 gap-[1.5px] overflow-hidden rounded-3xl border-[1.5px] border-ink-v2 bg-ink-v2 min-[900px]:grid-cols-2 min-[1100px]:grid-cols-3">
        {CATEGORIES.map((c) => (
          <div
            key={c.n}
            className="flex min-w-0 flex-col gap-2.5 bg-[#FFF3EF] px-[30px] pb-9 pt-8 transition-colors duration-[220ms] ease-[cubic-bezier(0.22,1,0.36,1)] hover:bg-white"
          >
            <span className="font-mono text-[13px] font-bold leading-none tracking-[0.06em] text-coral-500">
              {c.n}
            </span>
            <h3 className="mt-1 text-[21px] font-bold leading-[1.2] tracking-[-0.015em]">
              {c.name}
            </h3>
            <p className="max-w-[280px] text-[14px] leading-[1.5] text-warm-600">
              {c.desc}
            </p>
          </div>
        ))}

        <a
          href="#cta"
          className="flex min-w-0 flex-col gap-2.5 bg-ink-v2 px-[30px] pb-9 pt-8 text-cream-100 transition-colors duration-[220ms] ease-[cubic-bezier(0.22,1,0.36,1)] hover:bg-ink-v2-soft hover:text-cream-100"
        >
          <span className="font-mono text-[13px] font-bold leading-none tracking-[0.06em] text-lime-300">
            +
          </span>
          <h3 className="mt-1 text-[21px] font-bold leading-[1.2] tracking-[-0.015em] text-cream-100">
            Don&rsquo;t see your role?
          </h3>
          <p className="max-w-[280px] text-[14px] leading-[1.5] text-cream-100/70">
            We source to spec.{" "}
            <span className="font-bold text-lime-300">
              Tell us what you need &rarr;
            </span>
          </p>
        </a>
      </div>
    </section>
  );
}
